var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDrag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 2.5C11.75 2.5 11 3.25 11 4.16667C11 5.08333 11.75 5.83333 12.6667 5.83333C13.5833 5.83333 14.3333 5.08333 14.3333 4.16667C14.3333 3.25 13.5833 2.5 12.6667 2.5ZM12.6667 14.1667C11.75 14.1667 11 14.9167 11 15.8333C11 16.75 11.75 17.5 12.6667 17.5C13.5833 17.5 14.3333 16.75 14.3333 15.8333C14.3333 14.9167 13.5833 14.1667 12.6667 14.1667ZM12.6667 8.33333C11.75 8.33333 11 9.08333 11 10C11 10.9167 11.75 11.6667 12.6667 11.6667C13.5833 11.6667 14.3333 10.9167 14.3333 10C14.3333 9.08333 13.5833 8.33333 12.6667 8.33333Z",
    fill: "#B9B9B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 2.5C5.75 2.5 5 3.25 5 4.16667C5 5.08333 5.75 5.83333 6.66667 5.83333C7.58333 5.83333 8.33333 5.08333 8.33333 4.16667C8.33333 3.25 7.58333 2.5 6.66667 2.5ZM6.66667 14.1667C5.75 14.1667 5 14.9167 5 15.8333C5 16.75 5.75 17.5 6.66667 17.5C7.58333 17.5 8.33333 16.75 8.33333 15.8333C8.33333 14.9167 7.58333 14.1667 6.66667 14.1667ZM6.66667 8.33333C5.75 8.33333 5 9.08333 5 10C5 10.9167 5.75 11.6667 6.66667 11.6667C7.58333 11.6667 8.33333 10.9167 8.33333 10C8.33333 9.08333 7.58333 8.33333 6.66667 8.33333Z",
    fill: "#B9B9B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDrag);
export default __webpack_public_path__ + "static/media/icon_drag.998aea9ba13e2aad37f8b9892b7056be.svg";
export { ForwardRef as ReactComponent };